export const TEST_ID = 'groundedStatusBadge';
